import { ReactNode } from "react"

type BaseButtonColorway = "primary" | "secondary"
type BaseButtonVariant = "solid" | "ghost"

type BaseButtonProps = {
    label: string
    func: (e?: any) => void
    classProps?: string
    disabled?: boolean
    type?: "button" | "submit" | "reset"
    icon: ReactNode
    hideLabelOnMobile?: "sm" | "md" | "lg" | "xl" | "2xl" | "always"
    colorway?: BaseButtonColorway
    variant?: BaseButtonVariant
}

const colorwayClasses: Record<BaseButtonVariant, Record<BaseButtonColorway, string>> = {
    solid: {
        primary: "bg-white shadow-lg border-none hover:bg-gray-100",
        secondary: "bg-primary text-white shadow-lg border-none hover:brightness-95 [&_svg]:text-white",
    },
    ghost: {
        primary: "btn-ghost bg-transparent shadow-none text-primary hover:bg-primary/10",
        secondary: "btn-ghost bg-transparent shadow-none text-primary hover:bg-primary/10",
    },
}

export default function BaseButton(props: BaseButtonProps) {
    const colorway = props.colorway ?? "primary"
    const variant = props.variant ?? "solid"

    return (
        <button
            type={props.type}
            disabled={props.disabled}
            className={`btn ${colorwayClasses[variant][colorway]} ${props.classProps}`}
            onClick={props.func}>
            {props.icon}
            <p className={props.hideLabelOnMobile === "always" ? "hidden" : props.hideLabelOnMobile && `hidden ${props.hideLabelOnMobile}:block ${props.label === "" ? "!hidden" : ""}`}>{props.label}</p>
        </button>
    )
}
